import React from 'react'
import { Navigate, Route } from 'react-router-dom'

import { Callback, Error, Information, Login, Logout } from 'views'
import { SentryRoutes } from '../utils'

const Router = () => (
  <SentryRoutes>
    <Route path='/' element={<Login />} />
    <Route path='/logout' element={<Logout />} />
    <Route path='/error' element={<Error />} />
    <Route path='/login/informacoes' element={<Information />} />
    <Route path='/callback' element={<Callback />} />
    <Route path='*' element={<Navigate to='/' replace />} />
  </SentryRoutes>
)

export default Router
